import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { s } from "../UnbundlingFareInfographic.module-CzY5rohw.js";
const l = t => t.inclusions.map(o => /* @__PURE__ */n("li", {
  children: [o.infographicTitle, o.footnote && /* @__PURE__ */e("div", {
    className: s.stepFootnote,
    children: o.footnote
  })]
}, o._id));
export { l as UnbundlingFareInfographicStep };